import { MouseEvent, useState } from 'react';
import { twc } from 'react-twc';

import Modal from '@/components/Modal';
import PhotoBox from '@/components/PhotoBox';
import imgAltMaker from '@/utils/imgAltMaker';

const ReviewCarousel = ({ imgUrls }: { imgUrls: string[] }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedImgIdx, setSelectedImgIdx] = useState(0);

  const imgSrcs = [imgUrls[0], imgUrls[1], imgUrls[2]];

  const openImgModal = (e: MouseEvent<HTMLImageElement>) => {
    const index = e.currentTarget.dataset.index as string;

    setIsOpen(true);
    setSelectedImgIdx(Number(index) || 0);
  };

  const closeImgModal = () => {
    setIsOpen(false);
  };

  return (
    <>
      <div className="flex gap-2.5 h-13.5 lg:h-20">
        <div className="min-w-0 w-full flex-none flex gap-2">
          {imgSrcs.map((imgSrc, idx) => {
            if (!imgSrc) return <></>;
            return (
              <div
                key={imgAltMaker(imgSrc)}
                className="relative rounded-xl overflow-hidden size-13.5 2xl:size-20"
              >
                <ReviewImg
                  src={imgSrc}
                  alt={imgAltMaker(imgSrc)}
                  onClick={openImgModal}
                  data-index={idx}
                />
                {idx === 2 && imgUrls.length > 3 && (
                  <div
                    className="absolute top-0 left-0 w-full h-full bg-black/60 rounded-xl flex items-center justify-center text-white font-medium cursor-pointer"
                    data-index={idx}
                    onClick={openImgModal}
                  >
                    +{imgUrls.length - 3}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
      <Modal isOpen={isOpen} close={closeImgModal} allowEscClose bgClassName="bg-[#171719E5]">
        <PhotoBox imgUrls={imgUrls} defaultImgidx={selectedImgIdx} closeAction={closeImgModal} />
      </Modal>
    </>
  );
};

const ReviewImg = twc.img`object-cover border border-gray-5 size-13.5 2xl:size-20 cursor-pointer`;

export default ReviewCarousel;
